import { ApiTemplate, UserToken } from '../../../helper/HelperAuth';
import doFetch from '../../../infra/helper/fetchHelper';

export const getListPublishedFlow = async (paramBody) => {
  const argument = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: UserToken,
    },
    body: JSON.stringify(paramBody),
  };
  const response = await doFetch(ApiTemplate + 'flow/list-published', argument);
  return response;
};

export const getDetailFlow = async (flowId) => {
  const argument = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: UserToken,
    },
  };
  const response = await doFetch(
    ApiTemplate + 'flow/detail?flow_id=' + flowId,
    argument
  );
  return response;
};
